import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CustomerService, TemplateService } from '../_services/index';
import { ParameterData } from '../_helpers/index';
import { NotificationTemplate } from '../_models/index';
import { notificationStatus, notificationType } from '../_enums/index';

import { AngularEditorConfig } from '@kolkov/angular-editor';
import { event } from 'jquery';


@Component({
  selector: 'templates/create',
  templateUrl: './templatecreate.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css', 'templatecreate.component.css']
})
export class TemplateCreateComponent implements OnInit {
  tags: any[] = [];

  public notificationForm: FormGroup;
  public customer_public_id: string;
  isalertVisiable = false;
  statusresult: any;
  ddlnotificationtype: any[];
  ddlnotificationStatus: any[];
  public buttonValidate = false;
  notificationType : any[];
  htmlEditorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '25rem',
    minHeight: '5rem',
    placeholder: 'Texto aqui...',
    translate: 'no',
    uploadUrl: 'v1/images', // if needed
    customClasses: [ // optional
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };



  /**
   * constructor function is used to initialize 
   */
  constructor(
    private parameterData: ParameterData
    , private _fb: FormBuilder
    , private router: Router
    , private route: ActivatedRoute
    , private customerService: CustomerService
    , private _notificationType: notificationType
    , private _notificationStatus: notificationStatus
    , private templateService:TemplateService
  ) {
    this.isalertVisiable = false;
    this.ddlnotificationtype = _notificationType.dbtType;
    this.ddlnotificationStatus = _notificationStatus.Status;



  }


  /**
  * this Initial Setup function is used to initialize the form controls 
  **/
  InitialSetup() {

    this.notificationForm = this._fb.group({
      name: new FormControl("", Validators.required),
      type: new FormControl("EMAIL"),
      status: new FormControl("ACTIVE"),
      header: new FormControl("", Validators.required),
      content: new FormControl("", Validators.required),
      customer: this._fb.group({
        public_id: new FormControl(this.customer_public_id)
      })
    });


  }

  ngOnInit() {


    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');

      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');

    }
    this.getTemplateType();
    this.InitialSetup();
    this.getTagsApi();
  }

  getTemplateType() {
    this.templateService.getTemplateType(this.customer_public_id).subscribe(result => {

        this.notificationType = result.values.channels.filter(item => item.active == true && item.id != 'WHATSAPP');
    },
    error => {
        console.log('Failed while trying getType.' + error)
    })
}

  onsubmit({ value }: { value: NotificationTemplate }) {
    this.buttonValidate = true;


    this.customerService.createNotificationTemplate(this.customer_public_id, value)
      .subscribe((result) => {
       
        this.statusresult = "La información fue grabada correctamente !";
        this.isalertVisiable = true;


      }, error => {
        
        this.statusresult = error.error.Description;
        console.log('Failed while trying to update the Notification Templated Details.' + error);
      });

  }

  getTagsApi(){
    this.templateService.getTags().subscribe((data) => {
      this.tags=[
      {label: data[0].name, id: data[0].value},
      {label: data[1].name, id: data[1].value},
      {label: data[2].name, id: data[2].value},
      {label: data[3].name, id: data[3].value},
      {label: data[4].name, id: data[4].value},
      {label: data[5].name, id: data[5].value},
      {label: data[6].name, id: data[6].value},
      {label: data[7].name, id: data[7].value},
      {label: data[8].name, id: data[8].value},
      {label: data[9].name, id: data[9].value},
      {label: data[10].name, id: data[10].value},
      {label: data[11].name, id: data[11].value},
      {label: data[12].name, id: data[12].value},
      {label: data[13].name, id: data[13].value},
      {label: data[14].name, id: data[14].value},
      {label: data[15].name, id: data[15].value},
      {label: data[16].name, id: data[16].value},
      {label: data[17].name, id: data[17].value},
      {label: data[18].name, id: data[18].value},
      {label: data[19].name, id: data[19].value},
      {label: data[20].name, id: data[20].value},
      ]
      }, error => {        
        console.log('Failed while trying get Tags.' + error);
      });
  }

  onOptionSelected($event: Event): void {
    const value: any = $event;
    const value2:string= value
    var inputTemporal = document.createElement("textarea");
    inputTemporal.value = value2;
    document.body.appendChild(inputTemporal);
    inputTemporal.select();
    document.execCommand("copy");
    document.body.removeChild(inputTemporal);
   }
}//end

